module.exports = __webpack_public_path__ + "static/media/en-cancel-package_2.788e6fcb.png";